function getBodyTop() {
    return (
        (parseInt(document.querySelector('body').style.top.replace('px', '')) -
            document.documentElement.getBoundingClientRect().top) *
            -1 || 0
    )
}

const body = document.querySelector('body')
const documentEl = document.documentElement
const state = {
    noScroll: false,
    overlayModal: false,
    overlayDropdown: false,
    visibleDropdownOverlay: true,
    blockOverlay: false,
}

const mutations = {
    ALLOW_SCROLL() {
        const scrollTop = getBodyTop()
        body.classList.remove('block-content')
        body.style.top = null
        documentEl.scrollTop = scrollTop
    },
    BLOCK_SCROLL() {
        body.style.top = `${-documentEl.getBoundingClientRect().top * -1}px`
        body.classList.add('block-content')
    },
    OPEN_MODAL_OVERLAY(state) {
        state.overlayModal = true
    },
    CLOSE_MODAL_OVERLAY(state) {
        state.overlayModal = false
        state.visibleOnMobile = false
    },
    OPEN_DROPDOWN_OVERLAY(state, visibleDropdownOverlay) {
        state.overlayDropdown = true
        state.visibleDropdownOverlay = visibleDropdownOverlay
    },
    CLOSE_DROPDOWN_OVERLAY(state) {
        state.overlayDropdown = false
        state.visibleOnMobile = false
        state.visibleDropdownOverlay = true
    },
    BLOCK_OVERLAY(state, data) {
        state.blockOverlay = data
    },
}

const actions = {
    openOverlayModal({ commit, state }) {
        if (!state.blockOverlay) {
            commit('BLOCK_SCROLL')
            commit('OPEN_MODAL_OVERLAY')
        }
    },
    closeOverlayModal({ commit, state }) {
        if (!state.blockOverlay) {
            commit('ALLOW_SCROLL')
            commit('CLOSE_MODAL_OVERLAY')
        }
    },
    openOverlayDropdown({ commit, state }, visibleDropdownOverlay = true) {
        if (!body.classList.contains('block-content')) commit('BLOCK_SCROLL')
        if (!state.overlayDropdown) commit('OPEN_DROPDOWN_OVERLAY', visibleDropdownOverlay)
    },
    closeOverlayDropdown({ commit, getters }) {
        if (body.classList.contains('block-content') && !getters.overlayModal)
            commit('ALLOW_SCROLL')
        if (state.overlayDropdown) commit('CLOSE_DROPDOWN_OVERLAY')
    },
    blockScroll({ commit }, data) {
        if (data) commit('BLOCK_SCROLL')
        else commit('ALLOW_SCROLL')
    },
}

const getters = {
    overlayModal: (state) => state.overlayModal,
    overlayDropdown: (state) => state.overlayDropdown,
    blockOverlay: (state) => state.blockOverlay,
    visibleDropdownOverlay: (state) => state.visibleDropdownOverlay,
}

export default {
    state,
    mutations,
    actions,
    getters,
}
